import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { IonicModule } from '@ionic/angular';
import { firstValueFrom } from 'rxjs';

/*  FŐKÖNYVI KIVONAT – SZŰKÍTÉS. Az RLB „Szűkítés" ablakának mezői és szabályai egy helyen, hogy a
 *  Naplók kivonata és a könyvelés nézet kivonata ugyanazt tudja. A szűrő a szülőé; az ablak egy
 *  másolaton dolgozik, és csak a „Szűkít" gombra adja vissza. A szerver (kettos.js, fokonyvi-kivonat)
 *  ugyanezeket a szabályokat még egyszer érvényesíti. */
export interface KivonatSzuro {
  mind: boolean; tol: string; ig: string;
  szamla: string; szamla_op: string; szamla_tol: string; szamla_ig: string;
  munkaszam: string; munkaszam_op: string; msz_tol: string; msz_ig: string; msz_nelkul: boolean;
  partner_kod: string; partner_nev: string; partner_nev_op: string; deviza: string;
  deviza_ertek: boolean; elozo: boolean; elozo_nyito: boolean; partner_bontas: boolean; munkaszam_bontas: boolean;
}

export function uresKivonatSzuro(): KivonatSzuro {
  return {
    mind: false, tol: '', ig: '',
    szamla: '', szamla_op: 'eleje', szamla_tol: '', szamla_ig: '',
    munkaszam: '', munkaszam_op: 'eleje', msz_tol: '', msz_ig: '', msz_nelkul: false,
    partner_kod: '', partner_nev: '', partner_nev_op: 'eleje', deviza: '',
    deviza_ertek: false, elozo: false, elozo_nyito: false, partner_bontas: false, munkaszam_bontas: false,
  };
}

/** A szűrő query-stringje a /api/kettos/fokonyvi-kivonat végponthoz (csak a kitöltött mezők). */
export function kivonatQuery(sz: KivonatSzuro, ev: number | string): string {
  const q = new URLSearchParams({ ev: String(ev) });
  for (const [k, v] of Object.entries(sz)) {
    if (v === true) q.set(k, '1');
    else if (v !== false && v != null && String(v).trim() !== '') q.set(k, String(v).trim());
  }
  return q.toString();
}

/** Az aktív szűkítés szövegesen – chipnek a táblázat fölé. */
export function kivonatCimkek(s: KivonatSzuro): string[] {
  const c: string[] = [];
  const op = (v: string) => (v === 'pontos' ? '=' : v === 'tartalmaz' ? '∋' : '…');
  if (s.tol || s.ig) c.push(`Dátum: ${s.tol || '…'} – ${s.ig || '…'}`);
  if (s.szamla) c.push(`Főkönyvi szám ${op(s.szamla_op)} ${s.szamla}`);
  if (s.szamla_tol || s.szamla_ig) c.push(`Fők.sz.: ${s.szamla_tol || '…'} – ${s.szamla_ig || '…'}`);
  if (s.msz_nelkul) c.push('Munkaszám nélküli tételek');
  if (s.munkaszam) c.push(`Munkaszám ${op(s.munkaszam_op)} ${s.munkaszam}`);
  if (s.msz_tol || s.msz_ig) c.push(`Msz.: ${s.msz_tol || '…'} – ${s.msz_ig || '…'}`);
  if (s.partner_kod) c.push(`Partnerkód: ${s.partner_kod}`);
  if (s.partner_nev) c.push(`Partner ${op(s.partner_nev_op)} ${s.partner_nev}`);
  if (s.deviza) c.push(`Devizanem: ${s.deviza}`);
  if (s.deviza_ertek) c.push('Deviza értékek');
  if (s.elozo) c.push(s.elozo_nyito ? 'Előző időszak (nyitóval)' : 'Előző időszak');
  if (s.partner_bontas) c.push('Partnerenkénti alábontás');
  if (s.munkaszam_bontas) c.push('Munkaszámonkénti alábontás');
  return c;
}

@Component({
  selector: 'app-kivonat-szukites',
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule],
  templateUrl: './kivonat-szukites.component.html',
  styleUrls: ['../naplo-shared.scss', './kivonat-szukites.component.scss'],
})
export class KivonatSzukitesComponent implements OnChanges {
  @Input() nyitva = false;
  /*  'kivonat': a főkönyvi kivonat jelölőivel (deviza, előző időszak, alábontások); 'naplo': csak a
   *  feltételek – a többi napló (bank, vegyes, karton…) ugyanígy szűkíthető. */
  @Input() mod: 'kivonat' | 'naplo' = 'kivonat';
  /*  Mely feltételek értelmesek az adott listán (null = mind). Pl. a pénzügyi nyilvántartásban
   *  nincs munkaszám, a bank naplóban nincs partnerkód. */
  @Input() mezok: string[] | null = null;
  @Input() szuro: KivonatSzuro = uresKivonatSzuro();
  @Input() ugyfelId: string | null = null;
  @Output() szukit = new EventEmitter<KivonatSzuro>();
  @Output() bezar = new EventEmitter<void>();

  s: KivonatSzuro = uresKivonatSzuro();
  hiba = '';
  munkaszamok: any[] = [];
  tukor: any[] = [];
  partnerek: any[] = [];
  readonly illeszkedesek = [
    { v: 'eleje', c: 'Eleje egyezik' }, { v: 'pontos', c: 'Pontosan egyezik' }, { v: 'tartalmaz', c: 'Tartalmazza' },
  ];
  readonly devizanemek = ['EUR', 'USD', 'GBP', 'CHF', 'CZK', 'PLN', 'RON', 'SEK', 'NOK', 'DKK', 'JPY', 'CNY'];

  constructor(private http: HttpClient) {}

  ngOnChanges(ch: SimpleChanges) {
    if (ch['nyitva'] && this.nyitva) {
      this.s = { ...uresKivonatSzuro(), ...(this.szuro || {}) };
      this.hiba = '';
      this.torzsekBetolt();
    }
  }

  //  A mezők súgójához: munkaszámok, a teljes tükör (a gyűjtőkkel – intervallumhoz azok a jók), partnerek.
  private async torzsekBetolt() {
    const u = this.ugyfelId; if (!u) return;
    const get = (url: string) => firstValueFrom(this.http.get<any[]>(url)).catch(() => []);
    [this.munkaszamok, this.tukor, this.partnerek] = await Promise.all([
      get(`/api/kettos/munkaszamok/${u}`), get(`/api/kettos/szamlatukor/${u}`), get(`/api/naplo/partnerek/${u}`),
    ]);
  }
  van(m: string): boolean { return !this.mezok || this.mezok.includes(m); }

  /*  VÁLASZTÓ (▸) – a főkönyvi szám, a munkaszám és a partner a törzsből is kiválasztható, mint a
   *  könyvelőablakban. A kiválasztott kód (vagy partnernévnél a név) a mezőbe kerül. */
  valaszto: { fajta: 'szamla' | 'munkaszam' | 'partner'; cel: keyof KivonatSzuro; mit: 'kod' | 'nev' } | null = null;
  valasztoKereso = '';
  valasztoNyit(fajta: 'szamla' | 'munkaszam' | 'partner', cel: keyof KivonatSzuro, mit: 'kod' | 'nev' = 'kod') {
    this.valasztoKereso = ''; this.valaszto = { fajta, cel, mit };
  }
  get valasztoCim(): string {
    return { szamla: 'Főkönyvi szám kiválasztása', munkaszam: 'Munkaszám kiválasztása', partner: 'Partner kiválasztása' }[this.valaszto?.fajta || 'szamla'];
  }
  get valasztoLista(): { kod: string; nev: string; gyujto?: boolean }[] {
    const v = this.valaszto; if (!v) return [];
    const forras = v.fajta === 'szamla' ? this.tukor.map((t: any) => ({ kod: String(t.szamlaszam), nev: t.nev, gyujto: !!Number(t.gyujto) }))
      : v.fajta === 'munkaszam' ? this.munkaszamok.map((m: any) => ({ kod: String(m.kod), nev: m.nev || '' }))
      : this.partnerek.map((p: any) => ({ kod: String(p.kod ?? ''), nev: p.nev || '' }));
    const k = this.valasztoKereso.trim().toLowerCase();
    const lista = k ? forras.filter((x) => x.kod.toLowerCase().startsWith(k) || x.nev.toLowerCase().includes(k)) : forras;
    return lista.slice(0, 300);
  }
  valasztoValaszt(x: { kod: string; nev: string }) {
    const v = this.valaszto; if (!v) return;
    (this.s as any)[v.cel] = v.mit === 'nev' ? x.nev : x.kod;
    this.valaszto = null;
  }

  partnerNev(kod: any): string {
    const p = this.partnerek.find((x: any) => String(x.kod) === String(kod || '').trim());
    return p ? p.nev : '';
  }

  /*  Az RLB szabályai a jelölők között: devizás oszlopok mellé nincs nyitó/előző időszak, a nyitó
   *  napló beszámítása csak az előző időszakkal együtt értelmes, és a partneres meg a munkaszámos
   *  alábontás kizárja egymást. A tiltott jelölőt azonnal ki is kapcsoljuk. */
  igazit(mezo?: string) {
    const s = this.s;
    if (mezo === 'partner_bontas' && s.partner_bontas) s.munkaszam_bontas = false;
    if (mezo === 'munkaszam_bontas' && s.munkaszam_bontas) s.partner_bontas = false;
    if (s.deviza_ertek) { s.elozo = false; s.elozo_nyito = false; }
    if (!s.elozo) s.elozo_nyito = false;
    if (s.msz_nelkul) { s.munkaszam = ''; s.msz_tol = ''; s.msz_ig = ''; s.munkaszam_bontas = false; }
  }
  //  Enter = Szűkít (de nem, amíg a ▸ választó nyitva van – ott az Enter a találatot választja).
  enter(e: Event) { if (this.valaszto) return; e.preventDefault(); this.ok(); }
  alaphelyzet() { this.s = { ...uresKivonatSzuro(), mind: this.s.mind }; }
  ok() {
    if (this.s.tol && this.s.ig && this.s.tol > this.s.ig) { this.hiba = 'A dátum-intervallum kezdete későbbi, mint a vége.'; return; }
    this.igazit();
    this.szukit.emit({ ...this.s });
  }
}
